var path = 'src/app/forms/fields/checkbox-required-field.html';
var html = "<div class=checkbox> <label> <input frm-model checkbox-required-validator ng-model=model type=checkbox /> <span ng-transclude></span> </label> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/checkbox-required-field.html
 ** module id = 253
 ** module chunks = 0
 **/